/*
 * Horizontal product rail: the section pins and its cards travel sideways 1:1 with the vertical scroll, so the section
 * is exactly as tall as the sideways distance. Cards tilt in 3D under a finger or pointer. Without script (or with
 * reduced motion) it is a normal swipeable rail.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ex-rail]');
  if (!root) return;

  var track = root.querySelector('.ex-rl__track');
  var bar = root.querySelector('.ex-rl__bar');

  // 3D tilt (all visitors, including reduced motion keeps it off via CSS)
  [].slice.call(root.querySelectorAll('.ex-rl__link')).forEach(function (el) {
    function tilt(e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--rx', (-py * 9).toFixed(2) + 'deg');
      el.style.setProperty('--ry', (px * 11).toFixed(2) + 'deg');
    }
    function reset() { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); }
    el.addEventListener('pointermove', tilt);
    el.addEventListener('pointerdown', tilt);
    el.addEventListener('pointerleave', reset);
    el.addEventListener('pointerup', function () { setTimeout(reset, 220); });
    el.addEventListener('pointercancel', reset);
  });

  if (!track || !window.EluxaScroll || window.EluxaScroll.reduced()) return;

  var ov = 0;
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function measure() {
    ov = Math.max(0, track.scrollWidth - root.clientWidth);
    root.style.setProperty('--ov', ov + 'px');
    if (ov > 40) root.classList.add('is-anim'); else root.classList.remove('is-anim');
  }

  function render(p) {
    track.style.transform = 'translate3d(' + (-p * ov).toFixed(1) + 'px,0,0)';
    if (bar) bar.firstElementChild.style.setProperty('--f', p.toFixed(3));
  }

  measure();
  window.addEventListener('resize', function () { measure(); window.EluxaScroll.request(); });
  window.EluxaScroll.pin(root, render);
})();
